// New theme based on design_v2.html
export const themeV2 = {
  colors: {
    // Primary slate colors from design
    slate: {
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#64748b',
      600: '#475569',
      700: '#334155',
      800: '#1e293b',
      900: '#0f172a'
    },
    // Accent colors
    sky: {
      100: '#e0f2fe',
      500: '#0ea5e9'
    },
    indigo: {
      100: '#e0e7ff',
      500: '#6366f1'
    },
    emerald: {
      600: '#059669'
    },
    // Semantic colors
    white: '#ffffff',
    black: '#000000'
  },
  
  spacing: {
    xs: '0.25rem',    // 4px
    sm: '0.5rem',     // 8px
    md: '0.75rem',    // 12px
    lg: '1rem',       // 16px
    xl: '1.5rem',     // 24px
    '2xl': '2rem',    // 32px
    '3xl': '3rem',    // 48px
    '4xl': '4rem',    // 64px
    '6xl': '6rem',    // 96px
  },
  
  borderRadius: {
    sm: '0.375rem',   // 6px
    md: '0.5rem',     // 8px
    lg: '0.75rem',    // 12px
    xl: '1rem',       // 16px
    '2xl': '1rem',    // 16px (matching design)
    '3xl': '1.5rem',  // 24px
    full: '9999px'
  },
  
  typography: {
    fontFamily: {
      sans: ['Inter', 'ui-sans-serif', 'system-ui', '-apple-system', 'sans-serif']
    },
    fontSize: {
      xs: '0.75rem',     // 12px
      sm: '0.875rem',    // 14px
      base: '1rem',      // 16px
      lg: '1.125rem',    // 18px
      xl: '1.25rem',     // 20px
      '2xl': '1.5rem',   // 24px
      '3xl': '1.875rem', // 30px
      '4xl': '2.25rem',  // 36px
      '5xl': '3rem'      // 48px
    },
    fontWeight: {
      normal: '400',
      medium: '500',
      semibold: '600',
      bold: '700',
      extrabold: '800'
    },
    lineHeight: {
      tight: '1.25',
      normal: '1.5',
      relaxed: '1.75'
    }
  },
  
  shadows: {
    sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
    xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
    '2xl': '0 25px 50px -12px rgb(0 0 0 / 0.25)'
  },
  
  gradients: {
    hero: 'linear-gradient(to bottom, #f8fafc, #ffffff, #f8fafc)',
    cta: 'radial-gradient(circle at 20% 20%, #22d3ee, transparent 35%), radial-gradient(circle at 80% 30%, #a78bfa, transparent 35%), radial-gradient(circle at 40% 80%, #38bdf8, transparent 35%)'
  },
  
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px'
  },
  
  components: {
    button: {
      primary: {
        background: '#0f172a', // slate-900
        color: '#ffffff',
        borderRadius: '1rem', // rounded-2xl
        padding: '0 1.25rem', // px-5
        height: '2.75rem', // h-11
        fontSize: '0.875rem', // text-sm
        fontWeight: '500' // font-medium
      },
      secondary: {
        background: 'transparent',
        color: '#0f172a',
        border: '1px solid #e2e8f0', // border
        borderRadius: '1rem',
        padding: '0 1.25rem',
        height: '2.75rem',
        fontSize: '0.875rem',
        fontWeight: '500'
      }
    },
    card: {
      background: '#ffffff',
      border: '1px solid #e2e8f0',
      borderRadius: '1rem', // rounded-2xl
      padding: '1.5rem', // p-6
      boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)'
    },
    input: {
      background: '#ffffff',
      border: '1px solid #e2e8f0',
      borderRadius: '1rem',
      padding: '0 0.75rem',
      height: '2.75rem',
      fontSize: '0.875rem'
    }
  }
};

export default themeV2;